import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	container: {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},
	// Search Bar
	searchButton: {
		height: "53px",
	},
	searchHelperText: {
		margin: theme.spacing(0.5, 0.2),
		wordSpacing: "-0.1px",
		letterSpacing: "-0.2px",
		color: theme.palette.text.secondary,
	},
	// Search Result
	searchResultContainer: {
		marginTop: theme.spacing(1),
		border: `1px solid ${theme.palette.divider}`,
	},
	searchResultCardContent: {
		padding: theme.spacing(1, 2),
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1, 1.5),
		},
	},
	purchaseOrderNumber: {
		paddingLeft: theme.spacing(1),
	},
	searchResultFoundMessage: {
		marginBottom: theme.spacing(1),
	},
	manualReceiveCard: {
		marginTop: theme.spacing(1),
	},
	manualReceiveCardContent: {
		padding: theme.spacing(1),
		color: theme.palette.custom.searchResults.manualReceive.color,
		backgroundColor: theme.palette.custom.searchResults.manualReceive.background,
		"& strong": {
			color: theme.palette.custom.searchResults.manualReceive.note,
		},
	},
	searchCard: {
		marginTop: theme.spacing(1),
		border: `1px solid ${theme.palette.divider}`,
	},
	searchCardHighlighted: {
		marginTop: theme.spacing(1),
		border: "1px solid #028702",
		borderLeft: "5px solid #028702",
	},
	searchCardContent: {
		padding: `${theme.spacing(0.5, 1)} !important`,
	},
	titleText: {
		fontSize: "0.575rem",
	},
	valueText: {
		fontSize: "0.75rem",
	},
	checkIn: {
		minHeight: "35px", // I think this should be part of the theme
		padding: theme.spacing(1, 1.5),
	},
	statusContent: {
		textAlign: "center",
	},
	compactCard: {
		marginBottom: theme.spacing(1),
		"&:hover": {
			boxShadow: theme.shadows[3],
		},
	},
	compactCardContent: {
		padding: theme.spacing(1),
		"&:last-child": {
			paddingBottom: theme.spacing(1),
		},
	},
	compactGridItem: {
		padding: theme.spacing(0.5),
	},
	compactLabel: {
		marginBottom: 0,
		lineHeight: 1.2,
	},
	compactButton: {
		padding: theme.spacing(0.5, 1),
	},
	previousReceiveHeaderContainer: {
		fontWeight: 600,
		marginLeft: theme.spacing(1),
	},
	centeredText: {
		textAlign: "center",
	},
}));
